import RecentlyAddedPage from './RecentlyAddedPage'

export default RecentlyAddedPage
// eslint-disable-next-line import/export
export * from './RecentlyAddedPage'
